import type { PaymentMethodsConfig } from '../default/payment';
import type { DeepPartial } from '../default/types';

export const paymentMethodsConfig: DeepPartial<PaymentMethodsConfig> = {
  paymentMethods: {
    // IOGZ-434: explicit per-tenant textBased list so Bankeinzug stays independently controllable.
    textBased: ['invoice', 'flexikonto'],
  },
};
